<template>
  <img src="@/assets/images/cec2022/coming_soon.jpeg">
</template>

<script>
import {ButtonDetail} from '../../config/interface.js'
export default {
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
    methods:{
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        },
    }
}
</script>

<style scoped>
img{
    width: 100%;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/pages/cec2022/toContinue.vue